var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAstronaut({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 206,
    height: 213,
    viewBox: "0 0 206 213",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M111.093 60.49l-10.37 40.357a23.997 23.997 0 01-9.563 13.746l-13.79 9.568a39.978 39.978 0 00-6.196 5.314L55 146.5l16.572-16.572a40.008 40.008 0 016.394-5.194l14.896-9.74a23.998 23.998 0 0010.028-13.801l10.308-37.974a47.999 47.999 0 0128.676-32.065L205.5 6V0l-66.644 28.24a47.999 47.999 0 00-27.763 32.25z",
    fill: "url(#astronaut_svg__paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.274,
    d: "M30.882 159.235c17.056 0 30.882-13.826 30.882-30.882S47.938 97.471 30.882 97.471 0 111.297 0 128.353s13.826 30.882 30.882 30.882z",
    fill: "#515167"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.274,
    d: "M30.882 152.801c12.792 0 23.161-10.369 23.161-23.161 0-12.792-10.37-23.162-23.161-23.162-12.792 0-23.162 10.37-23.162 23.162s10.37 23.161 23.162 23.161z",
    fill: "#6F6F88"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.5 141c2.067-2.135 5.052-1.936 8.654.2 3.603 2.135 11.846 10.252 24.73 24.352l-7.27 8.298-29.564-27.053L60.5 141z",
    fill: "url(#astronaut_svg__paint1_linear)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M62.415 148.701c-.942-.975-2.341-1.693-4.2-2.154 4.933-10.645 6.333-19.709 4.2-27.19-2.133-7.482-7.913-14.155-17.338-20.02C35.5 95 21.844 97.257 18 99c-3.844 1.743-7 4.5-8.587 6.287l22.782 25.553L18 158c5.95 2.504 9.759 3.282 15.673 2.939 5.914-.342 10.792-1.817 14.635-4.423-1.426 2.795-3.105 5.066-5.035 6.813-1.931 1.747-4.53 3.347-7.798 4.8.68 11.066 6.424 21.101 17.231 30.104 10.808 9.003 21.327 11.611 31.56 7.823 1.218 2.61 2.363 4.247 3.435 4.911 3.51 2.173 7.824 1.915 8.18 1.368.518-.797-.649-6.828-3.5-18.092-4.772.521-8.79-.479-12.051-3-3.261-2.521-4.873-5.872-4.836-10.054C81.309 186.06 83.678 189.016 86 188c3.8-3.472 3.09-11.876 1.7-13.5-9.156-10.702-24.287-24.766-25.285-25.799z",
    fill: "#FEFEFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.193 180.557c4.803 5.496 8.963 8.782 15.837 11.81-2.6-1.849-3.53-2.367-5.03-4.867-1-2-1.5-4-1.507-6.311L57.05 161.604c1.291 7.14 4.339 13.458 9.143 18.953zM54.043 199.306c8.463 3.182 14.631 4.32 18.505 4.32 3.874 0 7.595-.153 11.162-1.365l.572 3.938C81.5 207 78 208.5 71 207.5c-4.5-1-10.201-2.588-16.957-8.194z",
    fill: "#EAEAF8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.7 177.474c.103 2.04.728 4.186 1.877 6.44 1.15 2.253 3.431 4.212 6.845 5.878l4.236-3.058c-1.993-2.434-3.405-4.416-4.236-5.944-.83-1.529-1.497-3.371-2-5.527l-6.721 2.211z",
    fill: "url(#astronaut_svg__paint2_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "astronaut_svg__paint0_linear",
    x1: 55,
    y1: 135,
    x2: 206,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#515167",
    stopOpacity: 0.04
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "astronaut_svg__paint1_linear",
    x1: 38.633,
    y1: 156.672,
    x2: 72.905,
    y2: 193.417,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8540"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E72828"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "astronaut_svg__paint2_linear",
    x1: 29.222,
    y1: 182.528,
    x2: 43.657,
    y2: 195.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8540"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E72828"
  })))));
}

export default SvgAstronaut;